<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-12 d-flex justify-content-start">
            <p class="ts-text-gray-500">
              <b><i><span class="text-danger">* </span>{{ $t('gradingdefinition.note') }}:
                </i></b>
              {{ $t('gradingdefinition.onlyuseratheadofficecanmodify') }}
            </p>
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 d-flex justify-content-end align-items-center">
            <label class="ts-text-xs mb-0 mr-1 ts-whitespace-no-wrap">
              {{ $t('school.academic.setup.program.grade.scoring_version') }} :
            </label>
            <a-select v-model="score_version_id" style="width: 200px" showSearch allowClear :placeholder="$t('all')"
              :filterOption="(input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .includes(input.toLowerCase())
                ">
              <a-select-option v-for="v in scoring_versions" :key="v.id" :value="v.id">{{ v.version_name
                }}</a-select-option>
            </a-select>
            <ts-input v-model="search" :placeholder="$t('search')" class="kh-font ml-2" style="width: 200px" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start">
            <a href="#" v-tooltip="'Copy'" class="mr-2 text-primary ts-text-xl" @click.prevent="copy()">
              <i class="fas fa-copy"></i>
            </a>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading" :rowGroup="{
        field: 'main_program.acp_name_foreign'
      }">
        <template v-slot="{ record }">
          <td>
            {{ record.sub_program ? record.sub_program.acps_name_foreign : '' }}
          </td>
          <td class="kh-font">
            {{ record.definition_name_kh }}
          </td>
          <td>
            {{ record.definition_name_en }}
          </td>
          <td>
            {{ record.definition_type }}
          </td>
          <td class="text-center">{{ record.grade }}</td>
          <td class="text-center">{{ record.description }}</td>
          <td class="text-center">
            {{ record.score_version ? record.score_version.version_name : '-' }}
          </td>
          <td class="text-center">
            <a href="#" v-tooltip="'Edit'" class="mr-2 text-primary" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import FormComponent from './form-copy.vue'

export default {
  props: ['fetch'],
  name: 'grading-definition-table',
  components: { FormComponent },
  data() {
    return {
      loading: false,
      columns: [
        { name: this.$t('gradingdefinition.subProgram') },
        { name: this.$t('gradingdefinition.meaningKH') },
        { name: this.$t('gradingdefinition.meaningEN') },
        {
          name: this.$t('gradingdefinition.definitionType'),
          style: 'text-align:center; width:8%'
        },
        {
          name: this.$t('gradingdefinition.grade'),
          style: 'text-align:center; width:8%'
        },
        { name: this.$t('gradingdefinition.description') },
        {
          name: this.$t('school.academic.setup.program.grade.scoring_version'),
          style: 'text-align:center'
        },
        {
          name: this.$t('gradingdefinition.actions'),
          style: 'text-align:center; width:1px'
        }
      ],
      scoring_versions: []
    }
  },
  created() {
    this.fetchScoreVersions()
  },
  computed: {
    ...mapState('gradingDefinition', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.gradingDefinition.search
      },
      set(newValue) {
        this.$store.commit('gradingDefinition/SET_SEARCH', newValue)
        this.$store.commit('gradingDefinition/RESET_CURRENT_PAGE')
      }
    },
    score_version_id: {
      get() {
        return this.$store.state.gradingDefinition.score_version_id
      },
      set(newValue) {
        this.$store.commit('gradingDefinition/SET_SCORE_VERSION_ID', newValue)
        this.$store.commit('gradingDefinition/RESET_CURRENT_PAGE')
        this.fetchData()
      }
    }
  },
  methods: {
    fetchScoreVersions() {
      this.$store
        .dispatch('gradingDefinition/getScoreVersions')
        .then(response => {
          this.scoring_versions = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetchData()
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('gradingDefinition/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('gradingDefinition/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'grading-definition-edit',
        params: { id: record.grade_definition_id }
      })
    },
    copy() {
      this.showForm()
    },
    showForm() {
      this.$modal.show(
        FormComponent,
        {
          fetch: this.fetch
        },
        {
          height: 'auto',
          scrollable: true,
          clickToClose: false,
          width: '30%',
          draggable: '.form-header'
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),

    fetch: function () {
      this.fetchData()
      this.$emit('fetched')
    }
  }
}
</script>
